module.exports = __webpack_public_path__ + "static/media/easy-customise.80fba52b.jpg";